module.exports = __webpack_public_path__ + "img/mt5Container1.6daadf22.png";